
import {Power1, TimelineMax, Power3, TweenLite} from "gsap";
import { PunkCounter } from "./PunkCounter";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { TextHandler } from "../../independent/text/TextHandler";
import { WinCounter } from "./WinCounter";
import { TranslationConfig } from "../../../translations/TranslationConfig";
import { Currency } from "@nolimitcity/slot-game/bin/core/balance/Currency";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class WinWaysCounter extends PunkCounter {

    protected textPoster:TextHandler;

    protected moveDownDistanceY:number = 40;
    
    protected xOffset:number = 0;
    
    constructor() {
        super({
            font : {
                name : "NumbersWinCountUp",
                size : 46
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this.position = new PIXI.Point(360,360);
        this._countUp.maxTextWidth = PunkEngineManager.ReelAreaWidth/1.35;
        this.zIndex = 2;
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);
        this.textPoster = new TextHandler();
    }

    public updateWinWays(value:number):void{
        this.textPoster.textObj.style.fontSize = 60;
        const txt:string = Translation.translate((value == 1 ? TranslationConfig.WAY_WON : TranslationConfig.WAYS_WON));
        this.textPoster.changeText(value.toString() + " " +  txt)
        this.textPoster.scale.set(0.6,0.6);
        this.updatePos(this.moveDownDistanceY);
    }

    public showWaysWonInst():void {
        this.updatePos(this.moveDownDistanceY);
        this.textPoster.alpha = 1;
    }

    public showWaysWon(duration:number):void {
        // this._countUp.alpha = 0;
        this.textPoster.alpha = 0;
        this.updatePos();
        const winCountPosY:number = WinCounter.normalCounter.position.y + ((WinCounter.normalCounter.counterBit.height/WinCounter.normalCounter.counterBit.scale.y) /2);

        this._timeline = Helper.timeLineKiller(this._timeline!,new TimelineMax());

        this._timeline.add([
            // TweenLite.to(this._countUp, duration, {alpha:1, ease:Power3.easeOut}),
            TweenLite.to(this.textPoster, duration, {alpha:1, ease:Power3.easeOut}),

            // TweenLite.fromTo(this._countUp.position, duration, {y:winCountPosY},{y:winCountPosY+this.moveDownDistanceY, ease:Power3.easeOut}),
            TweenLite.fromTo(this.textPoster.position, duration,{y:winCountPosY}, {y:winCountPosY+this.moveDownDistanceY, ease:Power3.easeOut}),
        ],0)
        this._timeline.play();
    }

    protected updatePos(valYOffset?:number):void{
        while(this.textPoster.textObj.width > 400) this.textPoster.textObj.style.fontSize -= 1;
        // WAY_WON
        const winCountPosY:number = WinCounter.normalCounter.position.y + ((WinCounter.normalCounter.counterBit.height/WinCounter.normalCounter.counterBit.scale.y) /2) + (valYOffset == undefined ? 0: valYOffset ) ;
        this.textPoster.position = new PIXI.Point( 350+this.xOffset , winCountPosY);
    }

    public showWaysCounter(duration:number):void {
        this.textPoster.textObj.style.fontSize = 60;
        while(this.textPoster.textObj.width > 400) this.textPoster.textObj.style.fontSize -= 1;

        this.textPoster.position = new PIXI.Point( 350+this.xOffset, 520);
        this.textPoster.changeText(Translation.translate(TranslationConfig.BANNER_WAYS));

        this.textPoster.show(duration);
        this._countUp.text = "729";
        this._countUp.updateCountUpTextPivot();
        this._timeline = Helper.timeLineKiller(this._timeline!,new TimelineMax());
        this._timeline.fromTo(this._countUp, duration,{alpha:0}, {alpha:1, ease:Power3.easeOut},0);
        this._timeline.fromTo(this._countUp.scale, duration*0.7,{x:0.4,y:0.4}, {x:1.1,y:1.1, ease:Power3.easeOut},0);
        this._timeline.to(this._countUp.scale, duration*0.3, {x:1,y:1},duration*0.7);
        this._timeline.play();
    }

    public countTowards(from:number, to:number, duration:number,size:number):void{
        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax({
            onStart:() => { while(this.textPoster.textObj.width > 500) this.textPoster.textObj.style.fontSize -= 1; },
            onUpdate:() => { while(this.textPoster.textObj.width > 500) this.textPoster.textObj.style.fontSize -= 1; },
        }));
        this._timeline.add([
            this._countUp.getCountUpAnimation(from, to, {duration : duration, ease : Power1.easeInOut, withDecimals:false}),
            TweenLite.fromTo(this.textPoster.scale, duration,{x:1 + size*0.1,y:1 + size*0.1}, {x:1 + (size+1)*0.1,y:1 + (size+1)*0.1, ease:Power3.easeOut}),
            TweenLite.fromTo(this._countUp.scale, duration,{x:1 + size*0.2,y:1 + size*0.2}, {x:1 + (size+1)*0.2,y:1 + (size+1)*0.2, ease:Power3.easeOut}),
        ]);
        this._timeline.play();
    }

    public waysWonHide():void{
        this._timeline = Helper.timeLineKiller(this._timeline as TimelineMax, new TimelineMax());
        this.updatePos(this.moveDownDistanceY);
        this._timeline.delay(0.6);
        this._timeline.fromTo(this.textPoster,0.2,{alpha:1},{alpha:0,ease:Power3.easeInOut},0);
    }

    public waysBigWonHide():void{
        this._timeline = Helper.timeLineKiller(this._timeline as TimelineMax, new TimelineMax({onUpdate:() => this.updatePos(this.moveDownDistanceY)}));
        this.updatePos(this.moveDownDistanceY);
        this._timeline.fromTo(this.textPoster,0.8,{alpha:1},{alpha:0});
    }

    public playTotalWin(value:number,duration?:number):void{
        this._countUp.text = Currency.formatValue(value);
        this._countUp.updateCountUpTextPivot();
        this._countUp.position = new PIXI.Point(20,40);
        this._countUp.scale.set(1,1);
        const tl:TimelineMax = new TimelineMax();
        tl.fromTo(this._countUp,0.2,{alpha:0},{alpha:1})
        tl.to(this,2,{})
        tl.to(this._countUp,0.5,{alpha:0})
        tl.play();
    }

    public waysHide(duration:number):void{
        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax());
        this._timeline.fromTo(this.textPoster,duration,{alpha:1},{alpha:0,ease:Power3.easeInOut},0);
        this._timeline.fromTo(this._countUp,duration,{alpha:1},{alpha:0,ease:Power3.easeInOut},0);
        this._timeline.play();
    }

    public onResize(xOffset:number = 0):void{
        this.position = new PIXI.Point(360+xOffset,360);
        this.xOffset = xOffset;
    }
}